<div class="kanban-search-bar">
  <mat-form-field appearance="outline" class="search-input">
    <mat-label>Search tasks </mat-label>
    <input matInput [formControl]="searchControl" placeholder="E.g., Jane" />
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>
  <div class="avatar-list-container">
    @for (user of users$ | async; track user.id) {
      <button
        class="avatar-wrapper"
        [class.selected]="selectedUsers.value?.includes(user.id)"
        [class.current]="currentUserId === user.id"
        (click)="selectUser(user.id)"
        [matTooltip]="user.email">
        {{ user.email[0] }}
      </button>
    }
  </div>
</div>

<div class="kanban-board-container">
  @for (column of taskColumns; track column.status; let idx = $index) {
    <div class="kanban-column" [id]="connectedTo[idx]">
      <div class="column-header">
        <h3 class="column-title">{{ column.status | kanbanId }}</h3>
        <span class="task-count">{{ column.tasks.length }}</span>
      </div>

      <div
        cdkDropList
        [cdkDropListData]="column.tasks"
        [id]="connectedTo[idx]"
        [cdkDropListConnectedTo]="connectedTo"
        class="task-list"
        cdkDropListSortingDisabled
        [cdkDropListDisabled]="isDisabled"
        (cdkDropListDropped)="drop($event, column.status)">
        @for (task of column.tasks; track task.task_id) {
          <mat-card
            cdkDrag
            (cdkDragStarted)="onDragStart(task.task_id)"
            (cdkDragEnded)="onDragEnd()"
            (cdkDragEntered)="onEnter($event)"
            (cdkDragExited)="onExit($event)"
            (cdkDragReleased)="onDragEnd()"
            class="task-card"
            [class.last-card]="lastGrabbed === task.task_id"
            [routerLink]="['.', { outlets: { 'task-details': [task.task_id] } }]"
            queryParamsHandling="preserve">
            <div class="priority-chip" [class]="'priority-' + task.priority + '-bg'">
              {{ task.priority }}
            </div>
            <div class="task-card-content">
              <h4 class="task-title">{{ task.name | titlecase }}</h4>

              @if (task.assigned_to) {
                <div class="task-footer">
                  <span [title]="task.assigned_to.name">
                    {{ task.assigned_to | shortId }}
                  </span>
                  <p [class.persona-avatar]="task.assigned_to.type === 'persona'" class="assignee-avatar">
                    {{ task.assigned_to.type[0] | uppercase }}
                  </p>
                </div>
              }
            </div>
            <div class="drag-button-holder">
              <div class="cdk-drag-handle drag-button" cdkDragHandle>
                <mat-icon>drag_indicator</mat-icon>
              </div>
              @if (task.due_date) {
                <span class="due-date-chip" [class.expired]="task.due_date | isDueDateExpired">
                  {{ task.due_date | date: 'MMM d' }}
                </span>
              }
            </div>
          </mat-card>
        }
        @if (isDragging && currentTargetList === connectedTo[idx]) {
          <div class="end-placeholder">
            <mat-icon>add_circle_outline</mat-icon>
            Drop here to append...
          </div>
        }
        @if (column.tasks.length === 0 && !(isDragging && currentTargetList === connectedTo[idx])) {
          <p class="empty-list-message">Drag tasks here or add a new one.</p>
        }
        <button
          *appRequiredRoles="[
            { role: 'admin', status: ['DRAFTING', 'IN_REVIEW', 'APPROVED'] },
            { role: 'reviewer', status: ['DRAFTING', 'IN_REVIEW'] },
            { role: 'editor', status: 'DRAFTING' }
          ]"
          [class.show-on-hover-column-button]="column.status !== 'todo'"
          mat-flat-button
          class="add-task-button"
          [disabled]="isDisabled"
          (click)="addNewTask(column.status)">
          <mat-icon>add</mat-icon>
          Add New Task
        </button>
      </div>
    </div>
  }
</div>
<router-outlet name="task-details"></router-outlet>
